/**
 * Nhãn "Đang xem: …" trên các trang báo cáo (#19869 / STAT-01b).
 *
 * <p>Cùng một trang trả hai con số khác nhau tuỳ `addy.branchId` có giá trị hay không (#19842), nên
 * một con số không kèm phạm vi là một con số đọc được theo hai nghĩa. Nhãn này là chỗ duy nhất nói
 * ra nghĩa đang dùng.
 *
 * <p>Không hiện ở phòng khám một chi nhánh và chưa ghim gì: ở đó mọi số vừa là số của chi nhánh vừa
 * là số của phòng khám, nên câu nhãn chỉ thêm tiếng ồn — đúng lý do `BranchSwitcher` tự ẩn.
 */
import { Building2 } from "lucide-react";

import { cn } from "@/lib/utils";
import { useBranchScope } from "./useBranchScope";

export function ReportScopeNotice({ className }: { className?: string }) {
  const scope = useBranchScope();

  if (scope.isLoading || !scope.showNotice) {
    return null;
  }

  return (
    <p
      className={cn(
        "mb-4 flex items-center gap-1.5 text-xs text-muted-foreground",
        className
      )}
    >
      <Building2 className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      Đang xem: <strong className="font-medium text-foreground">{scope.label}</strong>
    </p>
  );
}
